"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupHeadingRenderer = exports.OptionRenderer = exports.ErrorOptionRenderer = exports.InputRendered = exports.MenuListRendered = exports.NoOptionsMessageRenderer = exports.LoadingMessageRenderer = exports.EmptyRenderer = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_select_1 = require("react-select");
var Typography_1 = require("../../../Typography");
var LoadingMask_1 = require("../../../LoadingMask");
var types_1 = require("./types");
var utils_1 = require("./utils");
exports.EmptyRenderer = function () {
    return null;
};
exports.LoadingMessageRenderer = function () {
    return (react_1.default.createElement("div", { className: "gd-share-dialog-loading-mask-container" },
        react_1.default.createElement(LoadingMask_1.LoadingMask, { size: "small" })));
};
exports.NoOptionsMessageRenderer = function (props) {
    return (react_1.default.createElement("div", { className: "s-gd-share-dialog-no-option" },
        react_1.default.createElement(react_select_1.components.NoOptionsMessage, tslib_1.__assign({}, props))));
};
exports.MenuListRendered = function (props) {
    return (react_1.default.createElement(react_select_1.components.MenuList, tslib_1.__assign({}, props),
        react_1.default.createElement("div", { className: "s-gd-share-dialog-menu" }, props.children)));
};
exports.InputRendered = function (props) {
    return (react_1.default.createElement("div", { className: "gd-share-dialog-input s-gd-share-dialog-input" },
        react_1.default.createElement(react_select_1.components.Input, tslib_1.__assign({}, props))));
};
var OptionContentRenderer = function (item) {
    if (types_1.isGranteeUser(item.value)) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            item.label,
            " ",
            react_1.default.createElement("span", { className: "option-email" }, item.value.email)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        " ",
        item.label,
        " ");
};
exports.ErrorOptionRenderer = function (errorOption) {
    return (react_1.default.createElement("div", { className: "gd-share-dialog-option-error s-gd-share-dialog-option-error" },
        react_1.default.createElement("span", { className: "gd-share-dialog-option-error-content" }, errorOption.label)));
};
exports.OptionRenderer = function (props) {
    var className = props.className, cx = props.cx, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, data = props.data;
    if (types_1.isSelectErrorOption(data)) {
        return exports.ErrorOptionRenderer(data);
    }
    var sTestStyle = "";
    if (types_1.isGranteeItem(data.value)) {
        sTestStyle = utils_1.getGranteeItemTestId(data.value, "option");
    }
    var componentStyle = cx({
        option: true,
        "option--is-focused": isFocused,
    }, className);
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: innerRef, className: componentStyle + " " + sTestStyle }, innerProps),
        react_1.default.createElement("div", { className: "option-content" }, OptionContentRenderer(data))));
};
exports.GroupHeadingRenderer = function (props) {
    var label = props.data.label;
    return (react_1.default.createElement("div", { className: "gd-share-dialog-select-group-heading" },
        react_1.default.createElement(Typography_1.Typography, { tagName: "h3" }, label)));
};
//# sourceMappingURL=AsyncSelectComponents.js.map